import React from 'react';

const metrics = [
  { value: '47%', label: 'Ops Cost Reduced', context: 'Average across clients' },
  { value: '6 wks', label: 'To Production', context: 'From kickoff to live' },
  { value: '99.7%', label: 'System Uptime', context: 'Last 12 months' },
  { value: '0', label: 'AI Pilots Failed', context: 'In production, not demos' },
];

export default function Benefits() {
  return (
    <div className="win95-metrics-dialog">
      {/* Header like System Properties */}
      <div className="win95-metrics-header">
        <div className="win95-metrics-icon">📊</div>
        <div className="win95-metrics-title">
          <strong>System Metrics</strong>
          <span>Performance Statistics for Autonomous AI Systems</span>
        </div>
      </div>

      <hr className="win95-hr" />

      {/* Tagline */}
      <div className="win95-metrics-tagline">
        <strong>Results, not promises.</strong>
        <p>We measure success in production uptime, not slide decks.</p>
      </div>

      {/* Metrics Grid - Like System Properties panels */}
      <div className="win95-metrics-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', margin: '16px 0' }}>
        {metrics.map((m, i) => (
          <div key={i} className="win95-metric-box" style={{ padding: '16px', background: '#fff', border: '2px solid', borderColor: '#808080 #fff #fff #808080', textAlign: 'center' }} data-testid={`metrics-${i + 1}`}>
            <div className="win95-metric-value" style={{ fontSize: '28px', fontWeight: 'bold', color: '#000080', marginBottom: '4px' }}>{m.value}</div>
            <div className="win95-metric-label" style={{ fontSize: '12px', fontWeight: 'bold', color: '#000', marginBottom: '4px' }}>{m.label}</div>
            <div className="win95-metric-context" style={{ fontSize: '10px', color: '#666' }}>{m.context}</div>
          </div>
        ))}
      </div>

      {/* Progress Bar Section */}
      <div className="win95-groupbox" style={{ border: '2px solid', borderColor: '#808080 #fff #fff #808080', padding: '16px', margin: '12px 0', position: 'relative' }}>
        <div className="win95-groupbox-title" style={{ position: 'absolute', top: '-10px', left: '12px', background: '#c0c0c0', padding: '0 6px', fontWeight: 'bold', fontSize: '11px', color: '#000' }}>Reliability Status</div>
        <div className="win95-progress-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
          <span className="win95-progress-label" style={{ width: '120px', fontSize: '11px', color: '#000' }}>System Uptime:</span>
          <div className="win95-progress-track" style={{ flex: 1, height: '16px', background: '#fff', border: '2px solid', borderColor: '#808080 #fff #fff #808080', padding: '2px' }}>
            <div className="win95-progress-fill" style={{ width: '99.7%', height: '100%', background: '#000080' }}></div>
          </div>
          <span className="win95-progress-value" style={{ width: '50px', fontSize: '11px', fontWeight: 'bold', color: '#000080', textAlign: 'right' }}>99.7%</span>
        </div>
        <div className="win95-progress-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
          <span className="win95-progress-label" style={{ width: '120px', fontSize: '11px', color: '#000' }}>Project Success:</span>
          <div className="win95-progress-track" style={{ flex: 1, height: '16px', background: '#fff', border: '2px solid', borderColor: '#808080 #fff #fff #808080', padding: '2px' }}>
            <div className="win95-progress-fill" style={{ width: '100%', height: '100%', background: '#000080' }}></div>
          </div>
          <span className="win95-progress-value" style={{ width: '50px', fontSize: '11px', fontWeight: 'bold', color: '#000080', textAlign: 'right' }}>100%</span>
        </div>
      </div>

      {/* Footer */}
      <div className="win95-metrics-footer">
        <hr className="win95-hr" />
        <p>For inquiries, contact us through the <strong>Contact</strong> window.</p>
      </div>
    </div>
  );
}
